
<!-- ############################################## -->
<!-- ############# Sección de HTML ################ -->
<!-- ############################################## -->
<!-- 
	Definicion del diseño Default, altamente flexible y personalizado
	con ranuras o espacios para la visualizacion de vistas que hagan parte del patron por defecto de famisanar
 -->
<template>
	<v-app class="defaultLayout" > 
		<!-- <Navbar/> -->
		<slot/>
		<!-- <v-content>	
			
		</v-content> -->
		<Footer></Footer>
	</v-app>
</template>

<!-- ############################################## -->
<!-- ############# Seccion de Script ############## -->
<!-- ############################################## -->
<!-- 
	Espacio que permite la configuracion y definicion de propiedades, datos, metodos entre otros, determina 
	el comportamiento componente y su ciclo de vida  
 -->
<script>

	/**
	 * Definimos el modulo propio del componente, basado en las directivas de vuejs
	 */
	// import Navbar from '@/components/Navbar'
	import Footer from '@/components/Footer'

	/**
	 * Definimos el modulo propio del componente, basado en las directivas de vuejs
	 */
	export default {

		/**Objecto que permite registrar los componentes que hacen parte del diseño por defecto de la aplicacion */
		components: {

			/**Inyectamos el componente Navbar */
			// Navbar,

			/**Inyectamos el componente footer */
			Footer,
		}	
	}
</script>